module.exports = __webpack_public_path__ + "static/Screenshot (62)-1ebc03077bebf40f8b3358409f2931c0.png";